import appApi from '../../../../../api/app-api';

export const verifyOtpOperation = async (
  token: string,
  otp: string,
): Promise<void> => {
  try {
    await appApi.verifyPasswordResetOtp(token, Number(otp));
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
};
